import React from 'react';
import RoundedBlueContainer from '@components/container/RoundedBlueContainer';
import Edit from '@assets/icons/edit';

export interface DetailSectionProps {
  title: string;
  onEdit: () => void;
  children: React.ReactNode;
  className?: string;
}

const DetailSection = (props: DetailSectionProps) => {
  return (
    <div className={props.className}>
      <div className={'flex mb-2 font-black'}>
        <div className={'text-neutral-whiteboard/50 text-sm leading-5'}>
          {props.title.toUpperCase()}
        </div>
        <div
          onClick={props.onEdit}
          className={
            'cursor-pointer text-neutral-whiteboard ml-auto text-md leading-5'
          }
        >
          <Edit
            className={
              'fill-current text-primary-apricot w-4 mr-1 inline align-middle'
            }
          />
          Edit
        </div>
      </div>
      <RoundedBlueContainer>{props.children}</RoundedBlueContainer>
    </div>
  );
};

export default DetailSection;
